import { useTranslation } from "react-i18next"

import { FlowDirectionTooltipContent } from "@/components/fields/flow-direction-tooltip-content"
import { DataGridColumnHeader, baseColumnDef } from "@/nzds/data-grid"
import { useFormatFlowDirection } from "@/utils/bill/format-flow-direction"

import type { GridColDef, GridValidRowModel } from "@mui/x-data-grid-pro"

interface UseFlowDirectionColumnOptions {
  field?: string
}

export const useFlowDirectionColumn = <TRow extends GridValidRowModel>(
  options: UseFlowDirectionColumnOptions = {}
): GridColDef<TRow> => {
  const { t } = useTranslation("common")
  const { formatFlowDirection } = useFormatFlowDirection()
  const headerName = t("fields.flowDirection.title")
  const field = options.field ?? "flow_direction"

  return {
    ...baseColumnDef,
    field,
    filterable: false,
    flex: 1,
    headerName,
    maxWidth: 220,
    minWidth: 160,
    renderHeader: () => (
      <DataGridColumnHeader
        field={field}
        headerName={headerName}
        tooltipContent={<FlowDirectionTooltipContent />}
      />
    ),
    sortable: true,
    valueFormatter: (value: string | null | undefined) =>
      formatFlowDirection(value),
  }
}
